export const roleTypes = {
  admin: 'ADMIN',
  partner: 'PARTNER',
  api: 'API',
};

export const roleTypeOptions = [
  { value: roleTypes.admin, label: 'Admin' },
  { value: roleTypes.partner, label: 'Partner' },
  { value: roleTypes.api, label: 'API' },
];
